import request from "@/utils/request";
import store from "@/store";

export function register(data) {
  return request({
    url: "/api/user/",
    method: "post",
    data,
  });
}

export function login(data) {
  return request({
    url: "/api/user/login/",
    method: "post",
    data,
  });
}

export function getOrderList(page) {
  return request({
    url: "/api/user/ecommerce/orders/?page=" + page,
    method: "get",
    headers: { Authorization: "JWT " + store.state.user.accessToken },
  });
}

export function getOrderDetail(id) {
  return request({
    url: "/api/user/ecommerce/orders/" + id + "/",
    method: "get",
    headers: { Authorization: "JWT " + store.state.user.accessToken },
  });
}

export function sendQuestion(data) {
  return request({
    url: "/api/user/ecommerce/order_replies/",
    method: "post",
    data,
    headers: { Authorization: "JWT " + store.state.user.accessToken },
  });
}

export function getUserInfo() {
  return request({
    url: "/api/user/me/",
    method: "get",
    headers: { Authorization: "JWT " + store.state.user.accessToken },
  });
}

export function updateUserInfo(data) {
  return request({
    url: "/api/user/me/",
    method: "patch",
    data,
    headers: { Authorization: "JWT " + store.state.user.accessToken },
  });
}

export function verifyEmail(data) {
  return request({
    url: "/api/user/activation/",
    method: "post",
    data,
  });
}

export function resetPassword(data) {
  return request({
    url: "/api/user/reset_password/",
    method: "post",
    data,
  });
}

export function resetPasswordConfirm(data) {
  return request({
    url: "/api/user/reset_password_confirm/",
    method: "post",
    data,
  });
}
